import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"
import pythonLogo from '../assets/img/Python-Symbol.png';

export const Skills = () => {
  const skillGroups = [
    {
      title: "Data Engineering",
      className: "bg-pink",
      items: [
        "SQL", "PostgreSQL", "MySQL", "MongoDB", "BigQuery", "DBT",
        "Airflow", "PySpark", "Pandas", "NumPy", "Polars", "ETL/ELT",
        "Data Modeling", "Data Warehousing", "Parquet", "Pub/Sub",
        "Azure Data Factory", "CosmosDB", "Firestore", "Qdrant",
        "ChromaDB", "Elasticsearch", "Metadata Indexing",
        "JSON/XML Normalization", "Data Pipelines", "Feature Engineering",
        "Data Quality", "Power BI", "Tableau", "Streamlit"
      ]
    },
    {
      title: "Cloud & MLOps",
      className: "bg-orange",
      items: [
        "AWS", "GCP", "Azure", "SageMaker", "Bedrock", "Lambda",
        "S3", "SQS/SNS", "CloudWatch", "EC2", "EMR", "Azure ML",
        "Azure Functions", "Docker", "Docker Compose", "Kubernetes",
        "Terraform", "GitHub Actions", "GitLab CI", "CI/CD", "AWS RDS",
        "AWS ECR", "Azure OpenAI", "MLflow", "TensorBoard", "Langfuse",
        "Model Deployment", "Sentry", "Datadog", "Linux"
      ]
    },
    {
      title: "Software Engineering",
      className: "bg-orange",
      items: [
        "Python", "FastAPI", "Django", "Flask", "REST APIs", "AsyncIO",
        "WebSockets", "Celery", "Redis", "SQLAlchemy", "Pydantic",
        "HTTPX", "Poetry", "Pytest", "TDD", "E2E Testing", "Design Patterns",
        "Clean Architecture", "DDD", "Microservices", "API Design",
        "OpenAPI", "JWT/OAuth", "Uvicorn", "Click CLI", "Git", "Bash",
        "Type Hints", "Makefile", "Agile / Scrum"
      ]
    },
    {
      title: "AI / ML",
      className: "bg-red",
      items: [
        "LLM Agents", "MCP", "OpenAI", "LangChain", "LangGraph",
        "RAG", "VectorDB", "Prompt Engineering", "Multi-Agent Systems",
        "Evaluation Metrics", "NLP", "Computer Vision", "OCR",
        "PyTorch", "TensorFlow", "Hugging Face", "Transformers",
        "BERT", "Scikit-learn", "XGBoost", "YOLO", "Deep Learning",
        "Reinforcement Learning", "Recommender Systems", "Anomaly Detection",
        "Model Evaluation", "Time Series", "Financial Analytics", "Statistics", "Mathematics"
      ]
    }
  ];

  return (
    <section className="skill" id="skills">
      <h2>Strengths<img src={pythonLogo} alt="Python Logo" id="logo" /></h2>
      <div className="columns equal-columns">
        {skillGroups.map((group) => (
          <div className={`skill-column ${group.className}`} key={group.title}>
            <h3>{group.title}</h3>
            <ul className="flex-container">
              {group.items.map((item) => {
                const lengthClass = item.length > 20 ? " flex-item-xlong" : item.length > 14 ? " flex-item-long" : "";

                return (
                  <li className={`flex-item${lengthClass}`} key={item}>{item}</li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
      {/*</td>*/}
      <img className="background-image-left" src={colorSharp} alt="Background abstract" />
    </section>
  )
}
